import { useEffect, useState } from 'react'
import { Locale } from './Locale'
import { io } from 'socket.io-client'

let origin = window.location.origin

let socket = io(origin)

socket.connect()

export function OnlineStats() {
  const [count, setCount] = useState<number>()

  useEffect(() => {
    function onOnlineStats(count: number) {
      setCount(count)
    }
    socket.emit('online-stats')
    socket.on('online-stats', onOnlineStats)
    return () => {
      socket.off('online-stats', onOnlineStats)
    }
  })

  return (
    <>
      {count ? (
        <div className="online-stats">
          <Locale en="Online Users" zh_cn="在线用户" zh_hk="在線用戶" />:{' '}
          {count.toLocaleString()}
        </div>
      ) : null}
    </>
  )
}
